export const GET_ORDER_COLLECTION_SUCCESS = 'GET_ORDER_COLLECTION_SUCCESS';
